import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  iframe: {
    display: 'block',
    width: '100%',
    height: '80vh',
    border: 'none',
  },
}));

export default useStyles;
